import { FunctionComponent } from 'react';
import styles from "./Tag.module.css";
import cn from 'classnames';

export enum ITagTheme {
    SUCCESS= 'tagSuccess',
    WARN= 'tagWarn',
    DEFAULT= 'tagDefault',
};

export enum ITagSize {
    SMALL= 'tagSmall',
    NORMAL= 'tagNormal',
    BIG= 'tagBig',
};

interface ITagProps {
    label: string;
    theme?: ITagTheme;
    size?: ITagSize;
    className?: string;
};

const Tag: FunctionComponent<ITagProps> = ({label, theme, size,  className }) => {

    return (
        <div className={cn(styles.tag, styles[size || ''], styles[theme || ''], className)}>
            <span className='textTitle'>{label}</span>
        </div>
    );
};

export default Tag;
